import ScrollMagic from 'scrollmagic';

export default {
  init() {
      /* eslint-disable no-unused-vars */

    // JavaScript to be fired on the home page
      /*----------  ScrollMagic Homepage Scene  ----------*/


      // Init ScrollMagic
      var controller = new ScrollMagic.Controller();

      // get all slides
      var slides = ['#psa-item-1', '#psa-item-2', '#psa-item-3', '#psa-item-4'];


      // SCENE 1
      // add active class to each slide section
      slides.forEach(function(slide, index) {

          // number for highlighting scenes
          var num = index+1;

          // make scene
          var headerScene = new ScrollMagic.Scene({
              triggerElement: slide,
              offset: 150,
          })
              .setClassToggle('#psa-item-'+num, 'is-active')  // set class to active slide
              //.addIndicators()
              .addTo(controller);
      });

      /*----------  End Homepage Scene  ----------*/
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js